import classNames from 'classnames'
import { PropsWithChildren } from 'react'
import { Container, ContainerProps } from 'react-bootstrap'

export interface FiestrContainerProps extends ContainerProps {
  small?: boolean
  className?: string
}
const FiestrContainer = ({
  small,
  className,
  children,
}: PropsWithChildren<FiestrContainerProps>) => {
  return (
    <Container
      bsPrefix={small ? 'container-small' : 'container'}
      className={classNames(className)}
    >
      {children}
    </Container>
  )
}

export default FiestrContainer

// revise
// this file is used to create a custom container component that can be used in different parts of the application, we can pass the small prop to make the container smaller, as well as add any additional classes to the container. it was made so that we can have a consistent look and feel across the application. this should be used whenever we need a container in the application. the component is a functional component that takes in the props and children as arguments, and returns a Container component from react-bootstrap with the appropriate classes based on the props passed in. the component is exported as the default export.
